import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ExpertiseSection } from './components/ExpertiseSection';
import { EcommerceSection } from './components/EcommerceSection';
import { WorkSection } from './components/WorkSection';
import { SupportSection } from './components/SupportSection';
import { QuestionsSection } from './components/QuestionsSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
import { usePageMeta } from './hooks/usePageMeta';
import { useContactAnchor } from './hooks/useContactAnchor';
export function App() {
  usePageMeta({
    title: 'WebsiteForge | Custom Websites & Business Systems',
    description: 'Custom websites, SEO, advertising, ecommerce, and business automation planned and managed by one experienced team.',
    robots: 'noindex,nofollow'
  });
  useContactAnchor();
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="3ijfv1zlojwem">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-paper focus:px-4 focus:py-2 focus:font-bold" data-id="element-1" data-mp="3mkrchhuehbbq">
        
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="56m9egl55mh" />
      <main id="main" data-id="element-3" data-mp="7stfczkdj46">
        <HeroSection data-id="element-4" data-mp="2zllff2q1qmn9" />
        <ServicesSection data-id="element-5" data-mp="2zm4wyibsb90r" />
        <ExpertiseSection data-id="element-6" data-mp="2zmwit1fkxsdu" />
        <EcommerceSection data-id="element-7" data-mp="33mov9p83gioh" />
        <WorkSection data-id="element-8" data-mp="33lwy49yumcw3" />
        <SupportSection data-id="element-9" data-mp="33nggq77z9011" />
        <QuestionsSection data-id="element-10" data-mp="33oriy2lrxzq1" />
        <ClosingSection data-id="element-11" data-mp="38m1fs3bhtdnw" />
      </main>
      <SiteFooter data-id="element-12" data-mp="38l04bxqkep5n" />
    </div>;
}